import { Navigation, Autoplay, Swiper } from 'swiper';

import handleScroll from './modules/header-scroll';
import handleHover from './modules/navigation/appearance';
import HeaderMenu from './modules/navigation/menus';

import setupAnimation from './modules/animation';

import setupSelects from './modules/forms/select';

import setupHeroSlider from './modules/hero-section';

import setupBlog from './modules/blog';

import setupArticleNavigation from './modules/single/article-navigation';
import setupArticleProgress from './modules/single/article-progress';
import handleCopyUrl from './modules/single/copy-url';

import '../scss/styles.scss';

import teamPopup from './modules/team-sections/popup';

document.addEventListener('DOMContentLoaded', () => {
  handleScroll('.site-header');

  handleHover('.site-header-navigation', '.menu-item-button');
  handleHover('.site-header--networks-menu');
  handleHover('.site-footer-navigation');

  const networksMenu = new HeaderMenu('#bars-networks-menu', '#networks-menu', false);
  networksMenu.init();

  const mobileMenu = new HeaderMenu('#bars-mobile-menu', '#mobile-menu', true);
  mobileMenu.init();

  setupHeroSlider({ slider: '.hero-extended--slider', video: '.hero-extended video' });

  setupAnimation('.fade-up', 'fadeup');
  setupAnimation('.site-counter', 'counter');
  setupAnimation('.site-decoration', 'decoration');
  setupAnimation('.site-hero-decoration', 'hero-decoration');
  setupAnimation('.site-lottie-icons', 'lottie-icons');

  setupSelects('.site-select');

  setupBlog('.site-blog');
  setupArticleNavigation('.site-article');
  setupArticleProgress('.site-article-progress');

  handleCopyUrl('#copy-link');

  teamPopup('site-popup-card', 'site-popup', 'site-popup-exit', 'site-popup-overflow');
});

// partners slider
document.addEventListener('DOMContentLoaded', () => {
  const partnerSlider = document.getElementsByClassName('partners-slider__swiper');
  const partners = [];

  if (partnerSlider) {
    for (let i = 0; i < partnerSlider.length; i += 1) {
      const swiper = new Swiper(partnerSlider[i], {
        modules: [Autoplay],
        speed: 5000,
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        preventInteractionOnTransition: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        }
      });
      partners.push(swiper);
    }
  }
  //   partners[0].slideTo(3);
});

// tabs list
document.addEventListener('DOMContentLoaded', () => {
  const tabItem = document.querySelectorAll('.tabs-list__tab-title');
  const tabContent = document.querySelectorAll('.tabs-list__content-block');

  if (tabItem[0] && tabContent[0]) {
    tabItem[0].classList.add('active');
    tabContent[0].classList.add('active');

    for (let i = 0; i < tabItem.length; i += 1) {
      tabItem[i].addEventListener('click', () => {
        for (let c = 0; c < tabContent.length; c += 1) {
          if (i === c) {
            tabItem[c].classList.add('active');
            tabContent[c].classList.add('active');
          } else {
            tabItem[c].classList.remove('active');
            tabContent[c].classList.remove('active');
          }
        }
      });
    }
  }
});

//  slider reviews
document.addEventListener('DOMContentLoaded', () => {
  const sliderReviews = document.getElementsByClassName(`slider-reviews__swiper`);
  const sliderReviewsNext = document.getElementsByClassName('slider-reviews__btn-next');
  const sliderReviewsPrev = document.getElementsByClassName('slider-reviews__btn-prev');
  const reviews = [];

  if (sliderReviews) {
    for (let i = 0; i < sliderReviews.length; i += 1) {
      const swiper = new Swiper(sliderReviews[i], {
        modules: [Navigation],
        speed: 500,
        loop: true,
        spaceBetween: 32,
        slidesPerView: 'auto',
        preventInteractionOnTransition: true,
        // autoplay: {
        //   delay: 3000
        // },
        navigation: {
          nextEl: sliderReviewsNext[i],
          prevEl: sliderReviewsPrev[i]
        }
      });
      reviews.push(swiper);
    }
  }
});

//  slider wide
document.addEventListener('DOMContentLoaded', () => {
  const sliderWide = document.getElementsByClassName(`slider-wide__swiper`);
  const sliderWideNext = document.getElementsByClassName('slider-wide__btn-next');
  const sliderWidePrev = document.getElementsByClassName('slider-wide__btn-prev');
  const wide = [];

  if (sliderWide) {
    for (let i = 0; i < sliderWide.length; i += 1) {
      const swiper = new Swiper(sliderWide[i], {
        modules: [Navigation],
        speed: 500,
        loop: true,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        preventInteractionOnTransition: true,
        // autoplay: {
        //   delay: 3000
        // },
        navigation: {
          nextEl: sliderWideNext[i],
          prevEl: sliderWidePrev[i]
        }
      });
      wide.push(swiper);
    }
  }
});

//  slider social
document.addEventListener('DOMContentLoaded', () => {
  const sliderSocial = document.getElementsByClassName(`slider-social__swiper`);
  const wide = [];

  if (sliderSocial) {
    for (let i = 0; i < sliderSocial.length; i += 1) {
      const swiper = new Swiper(sliderSocial[i], {
        modules: [Autoplay],
        speed: 5000,
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        preventInteractionOnTransition: true,
        autoplay: {
          delay: 1,
          disableOnInteraction: false
        }
      });
      wide.push(swiper);
    }
  }
});
